<div style="position: relative; overflow-y: scroll; min-height: 200px;">
  <div
    style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: flex-start; justify-content: flex-start;">
    <div
      style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center;">
      @if (info !== null) {
      <div style="display: flex !important; align-items: center !important; justify-content: right !important;
        height:fit-content !important; width:100% !important;" (click)="onClose()">
        <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer;">
      </div>
      <div class="voucher-title bold-16px-center-marine primary-border-100"
        style="width: 100%; display: flex; align-items: center; justify-content: center; margin: 20px 0px">
        {{info.subject}}
      </div>
      }
    </div>
    <div style="display: flex; flex-direction: column; width: 100%;">
      @if (info.bodytext !== undefined && info.bodytext !== null && info.bodytext !== '') {
      <div class="voucher-text-row voucher-text-margin light-18px-center-marine"
        style="width: 100%; display: flex; align-items: center; justify-content: center; width: 100%; margin: 20px 0px; color: #0F223E !important; font-size: 14px !important;">
        {{info.bodytext}}
      </div>
      }
      @for (infoButton of info.subjectsButtons; track infoButton.id) {
      <div
        style="width: 100%; display: flex; flex-direction: row; align-items: center; justify-content: center; width: 100%;">
        @if (infoButton.subjectButton !== undefined && infoButton.subjectButton !== null && infoButton.url !== undefined
        && infoButton.url !== null) {
        <button mat-raised-button type="button" class="white-background regular-20px-center-marine" id="control2"
          #control
          style="box-shadow: none !important; width: 200px !important; border: 1px solid #0F223E; margin: 10px 0">
          <a class="voucher-text-row"
            style="width: 100%; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: bold; color: #0F223E; text-align: center; letter-spacing: -0.43px;"
            href="{{infoButton.url}}" target="_blank">
            {{infoButton.subjectButton}}
          </a>
        </button>
        }
      </div>
      }

    </div>
  </div>